import React from 'react';
import { View } from 'react-native';
import { styled } from 'dripsy';
import { observer } from 'mobx-react-lite';

import { Separator } from '../../common/Separator';
import { Comment } from '@models/Comments/CommentModel';
import { CommentList } from '@models/Comments/CommentListModel';
import {
  CommentInput,
  CommentInputModeEnum,
  ICommentInputProps,
} from '../CommentInput';
import { CommentViewLeftSpace } from './CommentItemLeftSpace';
import type { ICommentListStore } from '../CommentList';

const Container = styled(View)({
  flexDirection: 'row',
});

const InnerBarContainer = styled(View)({
  flex: 1,
});

export interface IReplyToCommentBarProps {
  item: Comment;
  commentListStore: ICommentListStore;
  commentInputSize?: ICommentInputProps['size'];
}

export const ReplyToCommentBar = observer<IReplyToCommentBarProps>(
  ({ item, commentListStore, commentInputSize }) => {
    const isShowReplyBar = commentListStore.isInCreateMode(item.id);

    if (!isShowReplyBar) {
      return null;
    }

    return (
      <Container>
        <CommentViewLeftSpace />

        <InnerBarContainer>
          <Separator size={['$5', '$6']} />

          <CommentInput
            target={{
              entity: item.comments as CommentList,
              mode: CommentInputModeEnum.Create,
            }}
            size={commentInputSize}
            onCancel={commentListStore.deleteId}
          />
        </InnerBarContainer>
      </Container>
    );
  },
);
